import React, { FC } from 'react';
import cx from 'classnames';
import { LogoVariants } from '../../types';
import styles from './Logo.css';
import { useTranslation } from '../../utils/translations';

type Props = {
  alt: string;
  className?: string;
  inverse?: boolean;
  logo: LogoVariants;
};

const Logo: FC<Props> = ({ alt, className, inverse, logo }): JSX.Element => {
  const { translate } = useTranslation();
  return (
    <>
      <img
        alt={translate(alt)}
        className={cx(styles.large, className)}
        src={
          inverse && logo.largeInverse
            ? logo.largeInverse.source
            : logo.large.source
        }
        width={logo.large.width}
        height={logo.large.height}
      />
      <img
        alt={translate(alt)}
        className={cx(styles.small, className)}
        src={logo.small.source}
        width={logo.small.width}
        height={logo.small.height}
      />
    </>
  );
};

export default Logo;
